import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {CloseButton} from './modal.style';
import Isvg from 'react-inlinesvg';
import closeImg from '../../../public/images/close.svg';

class AppModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.initModal = this.initModal.bind(this);
  }

  initModal() {
    return document.body;
  }

  handleCloseModal() {
    this.setState({showModal: false});
    const {callback} = this.props;
    if (callback) {
      callback();
    }
  }

  render() {
    const renderCloseButton = this.props.showCloseButton && <CloseButton onClick={this.handleCloseModal}><Isvg src={closeImg} /></CloseButton>;

    return (
      <div>
        <Modal
          isOpen={this.state.showModal}
          style={this.props.customStyles}
          onRequestClose={this.handleCloseModal}
          parentSelector={this.initModal}
          contentLabel="Modal"
          shouldCloseOnOverlayClick
        >
          {renderCloseButton}
          {React.cloneElement(this.props.children, {closeModalCallback: this.handleCloseModal})}
        </Modal>
      </div>
    );
  }
}

AppModal.propTypes = {
  children: PropTypes.node.isRequired,
  customStyles: PropTypes.object.isRequired,
  callback: PropTypes.func,
  showCloseButton: PropTypes.bool
};

export default AppModal;



// WEBPACK FOOTER //
// ./components/Modal/AppModal.js